export const USER = 'APP_USER';
export const ACCESS_TOKEN = 'APP_ACCESS_TOKEN';
export const IS_URL_TOKEN = 'IS_URL_TOKEN';
export const REFRESH_TOKEN = 'APP_REFRESH_TOKEN';
